export default __webpack_public_path__ + "static/media/phone_2.04d71a7c.svg";